import React from 'react';
import BrandKitDebugger from '../components/debug/BrandKitDebugger';
import ErrorBoundary from '../components/ErrorBoundary';

export default function BrandKitDebuggerPage() {
  return (
    <ErrorBoundary>
      <BrandKitDebugger />
    </ErrorBoundary>
  );
}